import { Copy, Flex, Square } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { FlexboxProps } from 'styled-system';

export interface INoResultsMsg {
  message: string;
  secondaryMessage?: string;
  insets?: number;
  color?: string;
  flexProps?: FlexboxProps;
}

export function NoResultsMsg({
  message,
  secondaryMessage,
  color = 'primaryText',
  flexProps = { alignItems: 'center', justifyContent: 'center' },
}: INoResultsMsg): JSX.Element {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Flex {...flexProps}>
      <Square inset="lg" style={{ textAlign: 'center' }}>
        <div className="ellipsisOverflow">
          <Copy variant="body" color={color}>
            {message}
          </Copy>
        </div>
        {secondaryMessage && (
          <div>
            <Copy variant="body" color="secondaryText">
              {secondaryMessage}
            </Copy>
          </div>
        )}
      </Square>
    </Flex>
  );
}
